export default __webpack_public_path__ + "static/media/6.c405c822.jpg";